import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const TTL_MS = 15 * 60 * 1000; // 15 minutes
const cache = new Map<string, { value: string; ts: number }>();
const pending = new Map<string, Promise<string>>();

function isValid(key: string): boolean {
  const entry = cache.get(key);
  return !!entry && Date.now() - entry.ts < TTL_MS;
}

export function useSiteSetting(key: string, fallback: string): string {
  const [value, setValue] = useState(() => cache.get(key)?.value ?? fallback);

  useEffect(() => {
    if (isValid(key)) {
      setValue(cache.get(key)!.value);
      return;
    }

    if (!pending.has(key)) {
      const p = new Promise<string>((resolve) => {
        supabase
          .from("site_settings" as any)
          .select("value")
          .eq("key", key)
          .single()
          .then(({ data }: any) => {
            const v: string = data?.value ?? fallback;
            cache.set(key, { value: v, ts: Date.now() });
            pending.delete(key);
            resolve(v);
          });
      });
      pending.set(key, p);
    }

    pending.get(key)!.then((v) => setValue(v));
  }, [key, fallback]);

  return value;
}
